<script setup>
defineProps({
  search: String,
  residentType: String,
  paymentStatus: String,
  residentTypeOptions: Array,
  paymentStatusOptions: Array,
});
defineEmits([
  "update:search",
  "update:residentType",
  "update:paymentStatus",
  "reset",
]);
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 mb-4">
    <div class="card-body p-4">
      <div class="row g-3 align-items-end">
        <div class="col-lg-5">
          <label class="form-label fw-semibold">ค้นหา</label>
          <input
            class="form-control"
            placeholder="ชื่อ, รหัสลูกบ้าน, ยูนิต, เบอร์โทร"
            :value="search"
            @input="$emit('update:search', $event.target.value)"
          />
        </div>

        <div class="col-lg-3">
          <label class="form-label fw-semibold">ประเภท</label>
          <select
            class="form-select"
            :value="residentType"
            @change="$emit('update:residentType', $event.target.value)"
          >
            <option
              v-for="o in residentTypeOptions"
              :key="o.value"
              :value="o.value"
            >
              {{ o.label }}
            </option>
          </select>
        </div>

        <div class="col-lg-3">
          <label class="form-label fw-semibold">สถานะการชำระ</label>
          <select
            class="form-select"
            :value="paymentStatus"
            @change="$emit('update:paymentStatus', $event.target.value)"
          >
            <option
              v-for="o in paymentStatusOptions"
              :key="o.value"
              :value="o.value"
            >
              {{ o.label }}
            </option>
          </select>
        </div>

        <div class="col-lg-1">
          <button class="btn btn-light border w-100" @click="$emit('reset')">
            <i class="bi bi-arrow-clockwise"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
